import type { NodeItem } from '@octopus-do/octopus-project-core'

import type { Ga4ReportPage } from './types'

// OCT-4991: у страницы один адрес — node.url. Фолбэков на notes.seoUrl и
// notes.seoSlug здесь намеренно нет: seoUrl уходит из модели, а слаг в живых
// проектах часто указывает на другую страницу (/uslugi против /services), то
// есть дал бы цифры не той страницы — хуже, чем пусто.
export const buildReportPages = (nodes: NodeItem[]): Ga4ReportPage[] =>
  nodes
    .map((node) => (node.url ? { nodeId: node.id, path: node.url } : null))
    .filter((page): page is Ga4ReportPage => page !== null)
